import { Pipe, PipeTransform } from '@angular/core';
import { DashboardWidget } from 'app/viewmodels/dashboard/dashboard-widget';
import { DashboardService } from '../dashboard.service';

@Pipe({
  name: 'displayWidgetUsingPermissions',
})
export class DisplayWidgetUsingPermissionsPipe implements PipeTransform {
  constructor(private dashboardService: DashboardService) {}

  transform(dashboardWidget: DashboardWidget): boolean {
    if (dashboardWidget && dashboardWidget.widget) {
      const { widget } = dashboardWidget;
      return this.dashboardService.checkUserHasPermissionsForWidget(widget.widgetDataType);
    }
  }
}
